<template>
  <div class="listrevenue">
    <table>
      <thead class="none">
        <tr>
          <td class="listrevenue__title title">Campaign</td>
          <td class="listrevenue__title periode">Periode</td>
          <td class="listrevenue__title number">Jumlah Lokasi</td>
          <td class="listrevenue__title number">Jumlah Hari</td>
          <td class="listrevenue__title number">Jumlah Screen</td>
          <td class="listrevenue__title number">Jumlah Slot</td>
          <td class="listrevenue__title price">Net Sales </td>
          <td class="listrevenue__title price">Host Revenue </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" v-if="!loading" :key="index" class="content">
          <td class="title"><span>{{item.campaign_name}}</span></td>
          <td class="periode">
            <span>{{displayPeriod(item.start_date, item.end_date)}}</span>
          </td>
          <td class="number"><span>{{displayValue(item.total_location)}}</span></td>
          <td class="number"><span>{{displayValue(item.calculated_days)}}</span></td>
          <td class="number"><span>{{displayValue(item.total_screen)}}</span></td>
          <td class="number"><span>{{displayValue(item.total_slot)}}</span></td>
          <td class="price">
            <span v-if="item.net_sales">{{item.net_sales | formatMoney}}</span>
            <span v-else> - </span>
          </td>
          <td class="price">
            <span v-if="item.host_revenue">{{item.host_revenue | formatMoney}}</span>
             <span v-else> - </span>
          </td>
        </tr>
      </tbody>
      <slot name="infiniteLoading"/>
    </table>
    <div class="emptyState">
      <adx-empty-selection v-if="isEmpty && !loading" />
    </div>
    <div class="listrevenue__loadingWrapper">
      <slot name="loading" />
    </div>
  </div>
</template>

<script>
import EmptySelection from '@/components/NotFound/Selection'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'

import moment from 'moment'

export default {
  name: 'adx-list-view',
  components: {
    'adx-empty-selection': EmptySelection
  },
  props: {
    items: {
      required: false
    },
    loading: {
      required: false
    }
  },
  data() {
    return {
      isEmpty: false
    }
  },
  updated() {
    if (this.items == 0) {
      this.isEmpty = true
    } else {
      this.isEmpty = false
    }
  },
  methods: {
    displayValue(value){
      if (value) {
        return value
      }
      return '-'
    },
    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YY', end)}`
      } else {
        return `-`
      }
    },
  },
  computed: {
    
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>